import { useLayoutEffect, useRef } from 'react'
import { useBanner } from './BannerContext'

export function Banner() {
    const { content } = useBanner()

    const ref = useRef<HTMLDivElement>(null)
    useLayoutEffect(() => {
        // No banner means no height. Without this the variable kept whatever the
        // last banner measured, because an unmounted node stops being observed
        // rather than reporting zero -- so a page sizing itself against the
        // chrome (see the packs screen) went on subtracting a strip that was no
        // longer on screen.
        if (!ref.current) {
            document.documentElement.style.setProperty('--page-banner-height', '0px')
            return
        }
        const ro = new ResizeObserver(() => {
            document.documentElement.style.setProperty(
                '--page-banner-height',
                `${ref.current.getBoundingClientRect().height}px`
            )
        })
        ro.observe(ref.current)
        return () => ro.disconnect()
    }, [content])

    if (!content) return null

    return (
        <div className='z-40 bg-[linear-gradient(270deg,#03CEFF_-4.35%,#C91FFF_100%)] w-full'>
            <div ref={ref} className='container-inline max-w-[var(--page-max-width)] mx-auto '>
                <div className='p-[0.5em] text-center font-bold text-[max(var(--text-2xs),0.825cqi)]'>{content}</div>
            </div>
        </div>
    )
}
